module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    attrs: {
      "id": "conversation"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGES')) + " ")]), _vm._v(" "), (_vm.isAllowed('send', 'report/message')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.newMessage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-2x"
  })]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.monitorInput),
      expression: "monitorInput"
    }],
    staticClass: "padding1",
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    ref: "gmonitor",
    attrs: {
      "value-key": "BusMonitorID",
      "filterable": "",
      "multiple": "",
      "placeholder": _vm.$t('GROUPSUPERVISOR')
    },
    on: {
      "change": function($event) {
        _vm.handleSelect()
      }
    },
    model: {
      value: (_vm.selectedMonitors),
      callback: function($$v) {
        _vm.selectedMonitors = $$v
      },
      expression: "selectedMonitors"
    }
  }, _vm._l((_vm.supervisors), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": _vm._FullName({
          NameEN: item.FullName_EN,
          NameAR: item.FullName_AR
        }),
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-tabs', {
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    staticStyle: {
      "margin": "-15px",
      "margin-top": "-14px"
    },
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('div', _vm._l((_vm.messages), function(message, key) {
    return _c('el-button', {
      key: key,
      staticClass: "list",
      class: [key == _vm.conversation ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.loadConversation(key)
        }
      }
    }, [(key == 0 && _vm.selectedMonitors.length > 1) ? _c('div', {
      staticClass: "img-circle",
      staticStyle: {
        "overflow": "hidden"
      }
    }, _vm._l((_vm.selectedMonitors), function(item, index) {
      return (index < 3) ? _c('div', {
        key: index,
        staticClass: "pull-left",
        staticStyle: {
          "box-sizing": "border-box",
          "overflow": "hidden"
        },
        style: ({
          width: _vm.imageWidth / (_vm.selectedMonitors.length < 3 ? _vm.selectedMonitors.length : 3) + 'px'
        })
      }, [_c('img', {
        style: ({
          marginLeft: -24 / (_vm.selectedMonitors.length < 3 ? _vm.selectedMonitors.length : 3) + 'px'
        }),
        attrs: {
          "src": _vm.getAsset(item.ImagePath, 'supervisor'),
          "alt": "",
          "width": "50",
          "height": "50"
        }
      })]) : _vm._e()
    })) : _c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": _vm.getAsset(message.monitor.ImagePath, 'supervisor')
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticStyle: {
        "flex": "1 1 0%",
        "min-width": "0",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(_vm._FullName({
      NameEN: message.monitor.FullName_EN,
      NameAR: message.monitor.FullName_AR
    })))]), _vm._v(" "), (_vm.messageCount(message) && key != 0) ? _c('el-badge', [_c('sup', {
      ref: "badge",
      refInFor: true,
      staticClass: "el-badge__content"
    }, [_vm._v(_vm._s(message.count))])]) : _vm._e(), _vm._v(" "), (key == 0) ? _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteNewMessage()
        }
      }
    }) : _vm._e()], 1)])
  }))])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading_board),
      expression: "loading_board"
    }],
    staticStyle: {
      "overflow": "hidden",
      "background": "#ddd"
    },
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "span": 18,
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.boardHeight + 'px'
    })
  }, [_c('div', {
    ref: "messages",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMore(_vm.messages[_vm.conversation])),
      expression: "isMore(messages[conversation])"
    }],
    on: {
      "click": _vm.loadOlderMessages
    }
  }, [_vm._v(_vm._s(_vm.$t('LOADOLDERMESSAGES')) + " "), _c('i', {
    staticClass: "fa fa-angle-double-up"
  })])], 1), _vm._v(" "), _vm._l((_vm.orderedConversations()), function(item, index) {
    return _c('el-card', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px !important"
      }
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('img', {
      staticClass: "img-circle",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "src": _vm.getAsset(item.ImagePath, item.FullName_EN == 'School' ? 'configuration' : 'supervisor', item.FullName_EN == 'School')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_vm._v(_vm._s(_vm._FullName({
      NameEN: item.FullName_EN,
      NameAR: item.FullName_AR
    })) + " "), _c('small', {
      staticClass: "pull-right"
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" " + _vm._s(item.datetime))])]), _vm._v("\n                " + _vm._s(item.Text) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "media-footer"
    }, [(item.FileName) ? _c('el-button', {
      staticClass: "pull-right fa fa-download",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.showAttachment(item.FileName, item.FileType)
        }
      }
    }) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('el-card', {
    ref: "formCard",
    staticStyle: {
      "border-width": "0",
      "border-top-width": "1px",
      "border-left-width": "1px"
    }
  }, [_c('el-input', {
    ref: "msgInput",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "disabled": !_vm.isAllowed('send', 'report/message'),
      "placeholder": _vm.$t('WRITEYOURMESSAGE')
    },
    model: {
      value: (_vm.compose.Text),
      callback: function($$v) {
        _vm.$set(_vm.compose, "Text", $$v)
      },
      expression: "compose.Text"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    attrs: {
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.updateFile,
      "on-progress": _vm.limitFile,
      "disabled": !_vm.isAllowed('send', 'report/message'),
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "with-credentials": true,
      "action": _vm.URL + 'media/upload',
      "data": {
        folder: _vm.folder,
        type: 'attachment'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('send', 'report/message'),
      "size": "small",
      "type": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.$t('ATTACHEMENT')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('FILESWITHASIZELESSTHAN')) + " ")])], 1)], 1), _vm._v(" "), (_vm.compose.Attachment.Filename) ? _c('el-col', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.compose.Attachment.Filename))]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.compose.Attachment.Filename ? 6 : 16
    }
  }, [_c('el-button', {
    staticClass: "reply",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.validateReply(),
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.replyConversation()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingSend ? _vm.$t('SENDING') : _vm.$t('REPLY')))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-doc-dialog', {
    attrs: {
      "visible": _vm.imageVisible,
      "document": _vm.imageSrc,
      "title": "ATTACHEMENT",
      "subFolder": "messages"
    },
    on: {
      "update:visible": function($event) {
        _vm.imageVisible = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.errorMessage), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb026634"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Message.vue
// module id = 623
// module chunks = 1